import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DvrIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dvr"}/>
}
